module.exports = __webpack_public_path__ + "fonts/Canaro-BookItalic.13fa9912.woff";